const CourseModuleService = function () {
  this.saveModuleProgress = function (view, page, mod) {
    this.saveModule(mod);
    view.render();
  };

  this.saveModule = function (mod) {
    mod.save();
  };
};

export default new CourseModuleService();
